import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FormPage from './containers/Pages/FormPage';
import ResultPage from './containers/Pages/ResultPage';

function App() {
  const [versions, setVersions] = useState([]);
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    axios.get('/api/features')
      .then(r => {
        setFeatures(r.data);
      })
  }, []);

  useEffect(() => {
    axios.get('/api/versions')
      .then(r => {
        setVersions(r.data);
      })
  }, []);

  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Switch>
        <Route path="/results">
          <ResultPage features={features} />
        </Route>
        <Route path="/version">
          <FormPage form="versionForm" versions={versions} features={features} />
        </Route>
        <Route path="/newVersion">
          <FormPage form="newVersion" versions={versions} features={features} />
        </Route>
        <Route path="/queryBuilder">
          <FormPage form="queryBuilder" versions={versions} features={features} />
        </Route>
        <Route path="/queryResults">
          <FormPage form="queryResults" versions={versions} features={features} />
        </Route>
        <Route path="/connectionCreation">
          <FormPage form="connectionCreation" versions={versions} features={features} />
        </Route>
        <Route path="/">
          <FormPage form="empty" versions={versions} features={features} />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
